import clsx from "clsx";
import UploadDrag from "../UploadDrag/UploadDrag";
import UploadLoading from "../UploadLoading/UploadLoading";
import { UploadInputDisplayRoot } from "./UploadInputDisplay.styles";
import { UploadInputDisplayProps, UploadInputDisplaySize } from "./UploadInputDisplay.types";

export const LITTLE_LOADER_SIZES: UploadInputDisplaySize[] = ["xs", "sm"];

const UploadInputDisplay = ({
    className,
    children,
    size = "md",
    fullWidth,
    isLoading,
    showLoading: showLoadingProp,
    showError: showErrorProp,
    showSuccess: showSuccessProp,
    isEditable,
    isSuccess: isSuccessProp,
    isError: isErrorProp,
    drag,
    fileUri,
    dragElement,
    ...rest
}: UploadInputDisplayProps) => {
    const isSuccess = showSuccessProp && fileUri && isSuccessProp && !isLoading;
    const isError = showErrorProp && isErrorProp && !isLoading;
    const showLoading = showLoadingProp && isLoading;

    return (
        <UploadInputDisplayRoot
            flex={1}
            alignItems="center"
            justifyContent="center"
            size={size}
            className={clsx("upload-input-display", size, className, {
                drag,
                fullWidth,
                isLoading,
                isEditable,
                isSuccess,
                isError,
            })}
            {...rest}
        >
            {drag && dragElement ? (
                <UploadDrag>{dragElement}</UploadDrag>
            ) : (
                <>
                    {showLoading && <UploadLoading size={LITTLE_LOADER_SIZES.includes(size) ? "sm" : "md"} />}
                    {children}
                </>
            )}
        </UploadInputDisplayRoot>
    );
};

export default UploadInputDisplay;
